module.exports = __webpack_public_path__ + "img/password.f4c4e2f7.png";